// Cihaz fiyatları kuruş cinsinden saklar (1 TL = 100 kuruş).
export const kurusToTl = (kurus) => (Number(kurus) || 0) / 100;
export const tlToKurus = (tl) => {
  const n = Number(tl);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100);
};
export const formatTl = (kurus) => {
  const tl = kurusToTl(kurus);
  return `${tl.toFixed(2).replace(".", ",")} ₺`;
};
export const karsilikLabel = (kurus) => {
  const k = Number(kurus) || 0;
  return `= ${formatTl(k)} (${k} kuruş)`;
};
